import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["content", "toggleIcon", "setsTable"];
  static values = { id: String };

  connect() {
    // Check if this exercise was previously expanded
    const expandedExerciseIds = this.getExpandedExerciseIds();
    if (expandedExerciseIds.includes(this.idValue)) {
      this.contentTarget.classList.remove("d-none");
      this.toggleIconTarget.classList.remove("bi-chevron-down");
      this.toggleIconTarget.classList.add("bi-chevron-up");
    }

    // Add touchend event handler to all form submit buttons
    this.addTouchEventsToButtons();
  }

  toggle(event) {
    this.contentTarget.classList.toggle("d-none");
    const isExpanded = !this.contentTarget.classList.contains("d-none");

    // Toggle the icon between down and up
    if (isExpanded) {
      this.toggleIconTarget.classList.remove("bi-chevron-down");
      this.toggleIconTarget.classList.add("bi-chevron-up");
      // Add to expanded exercises
      this.addExpandedExercise(this.idValue);
    } else {
      this.toggleIconTarget.classList.remove("bi-chevron-up");
      this.toggleIconTarget.classList.add("bi-chevron-down");
      // Remove from expanded exercises
      this.removeExpandedExercise(this.idValue);
    }
  }

  preventToggle(event) {
    // Prevent the toggle action when clicking on the drag handle
    event.stopPropagation();
  }

  refreshSets() {
    // No need to save state here as it's already saved in localStorage
    // Refresh the page to show updated sets
    window.location.reload();
  }

  addTouchEventsToButtons() {
    // Find all form submit buttons in this exercise's card
    if (this.contentTarget) {
      const submitButtons = this.contentTarget.querySelectorAll(
        'input[type="submit"]'
      );
      submitButtons.forEach((button) => {
        button.addEventListener("touchend", (e) => {
          // Prevent default to avoid double-triggering
          e.preventDefault();
          // Submit the parent form
          button.form.submit();
        });
      });
    }
  }

  // Helper methods for managing expanded exercise IDs
  getExpandedExerciseIds() {
    const storedIds = localStorage.getItem("expandedExerciseIds");
    return storedIds ? JSON.parse(storedIds) : [];
  }

  addExpandedExercise(id) {
    const expandedIds = this.getExpandedExerciseIds();
    if (!expandedIds.includes(id)) {
      expandedIds.push(id);
      localStorage.setItem("expandedExerciseIds", JSON.stringify(expandedIds));
    }
  }

  removeExpandedExercise(id) {
    const expandedIds = this.getExpandedExerciseIds();
    const updatedIds = expandedIds.filter((expandedId) => expandedId !== id);
    localStorage.setItem("expandedExerciseIds", JSON.stringify(updatedIds));
  }
}
